module.exports = __webpack_public_path__ + "img/instagram.b7c18b96.svg";